import { initialState } from "./state";

export default {
  setValue(state, { property, data }) {
    state[property] = data;
  },
  setFilterValue(state, { property, data }) {
    state.filters[property] = data;
  },
  setHasAccessLevel(state, data)
  {
    state.hasAccessLevel = data;
  },
  setIsAdmin(state, data) {
    state.isAdmin = data;
  },
  setFilters(state, data) {
    state.filters.academicYear = data.academicYear;
    state.filters.sieorRegId = null;

    state.filters.center = data.center;
    state.filters.municipality = data.municipality;
    state.filters.status = null;
    state.filters.requestType = data.requestType;
    state.filters.determinationType = data.determinationType;
    state.filters.numberTapRequest = null;
    state.filters.amendmentProcess = data.amendmentProcess;
  },
  setCollections(state, data) {
    this.setAcademicYears(state, data.academicYears);
    this.setCenters(state, data.centers);
    this.setMunicipalities(state, data.municipalities);
  },
  setResults(state, results) {
    state.results = results;
  },
  setResultsIdx(state, { result, idx }) {
    state.results[idx] = result;
  },
  setPagination(state, conf) {
    state.pagination = conf;
  },
  setCurrentPage(state, pageNumber) {
    state.pagination.currentPage = pageNumber;
  },
  setAcademicYears(state, data) {
    state.collections.academicYears = data;

    let selectedAcademicYear = data.find(x => x.selected);

    if (selectedAcademicYear != undefined) {
      state.filters.academicYear = selectedAcademicYear;
    }
  },
  setAmendmentProcess(state, data) {
    state.collections.centers = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.amendmentProcess = data[0];
      state.amendmentProcessDisabled = true;
    } else {
      state.amendmentProcessDisabled = false;
    }
  },
  setCenters(state, data) {
    state.collections.centers = data || [];
    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.center = data[0];
      state.centerDisabled = true;
    } else {
      state.centerDisabled = false;
    }
  },
  setMunicipalities(state, data) {
    state.collections.municipalities = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.municipality = data[0];
      state.municipalityDisabled = true;
    } else {
      state.municipalityDisabled = false;
    }
  },
  setSchools(state, data) {
    state.collections.schools = data || [];

    if (data != null && data.length == 1 && data[0].selected) {
      state.filters.school = data[0];
      state.schoolDisabled = true;
    } else {
      state.schoolDisabled = false;
    }
  },
  setStatus(state, data) {
    state.collections.status = data || [];
  },
  setAmendmentProcess(state, data) {
    state.collections.amendmentProcess = data || [];
  },
  setStudentSIE(state, data) {
    state.studentSIE = data;
  },
  resetByAcademicYear(state) {
    state.filters.municipality = null;
    state.filters.school = null;
    state.filters.center = null;

    state.collections.municipalities = [];
    state.collections.schools = [];
    state.collections.centers = [];
  },
  resetByCenter(state) {
    state.filters.municipality = null;
    state.filters.school = null;

    state.collections.municipalities = [];
    state.collections.schools = [];
  },
  resetByMunicipality(state) {
    state.filters.school = null;

    state.collections.schools = [];
  },
  resetResults(state) {
    state.results = [];
  },
  resetAll(state) {
    Object.assign(state, initialState());
  }
};
